import request from '@/utils/request'

// 获取用户当前是第几天签到
export function userDay(query) {
  return request({
    url: '/h5/userSign/userDay',
    method: 'get',
    params: query
  })
}

// 新增用户签到记录
export function addUserSign(day,integral) {
  return request({
    url: '/h5/userSign/addUserSign/'+day+'/'+integral,
    method: 'get'
  })
}
